import { makeStyles } from "@material-ui/core/styles";

export const flyerStyles = makeStyles(() => ({
  container: {
    width: "100%",
    "text-align": "left",
    padding: "20px",
  },
}));
